// 头部搜索导航栏
<template>
  <div class="container">
    <div class="justdisplay">
      <div class="sld_home_top_search">
        <div class="header_logo">
          <router-link tag="a" class="sld_logo_wrap" :to="`/index`">
            <img :src="ooimage" :onerror="defaultImg" alt />
          </router-link>
        </div>
        <div v-if="!searchBox" class="header_center">
          <div class="product_sort" @click="toGoodsList">
            <img
              style="margin-right:0px; width:25px; height:25px"
              :src="sortUrl"
              alt
            />
            <span class="sort">{{ L['产品分类'] }}</span>
          </div>

          <nav class="fontSize">
            <!-- <Search
              style="width: 16px; height: 16px; margin-right: 8px; color:#000"
            /> -->
            <li class="" v-if="showIndex"><a href="/">{{ L['首页'] }}</a></li>
            <li v-for="(item, index) in navList.data" :key="index">
              <a href="javascript:void(0)" @click="navClick(item)">{{
                item.navName
              }}</a>
            </li>
          </nav>
        </div>
        <div v-else class="sld_seach_box">
          <div class="sld_seach">
            <div class="form" @submit.prevent>
              <svg
                class="svg_search_icon"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                data-v-029747aa=""
                @click="search"
              >
                <path
                  fill="currentColor"
                  d="m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704z"
                ></path>
              </svg>
              <input
                v-model="keyword"
                type="text"
                class="text"
                autocomplete="off"
                style="color:rgb(153,153,153);"
                :placeholder="L['请输入关键词']"
                @keyup.enter="search"
              />
              <svg
                class="svg_close_icon"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                data-v-029747aa=""
                @click="closeSearch"
              >
                <path
                  fill="currentColor"
                  d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
                ></path>
              </svg>
              <!-- <input
                type="submit"
                :value="L['搜索']"
                class="button"
                @click="search"
              /> -->
            </div>
          </div>
          <div class="hot_search_wrap">
            <div>
              <template v-for="(item, index) in hotList.data" :key="index">
                <a href="javascript:void(0)" @click="quickSearch(item)">{{
                  item
                }}</a>
              </template>
            </div>
          </div>
        </div>
        <CategorySort :showCategorySort="showCategorySort" />
        <div class="header_right">
          <!-- <img src="@/assets/header/user.jpg" alt="" /> -->
          <img
            class="searchIcon"
            @click="showSearchBox"
            src="@/assets/header/search.png"
            alt=""
          />
          <el-tooltip :content="L['发布询价']" placement="bottom" effect="light">
            <img @click="toRelease" src="@/assets/header/askprice.png" alt="" />
          </el-tooltip>
          <div class="sld_cart_wrap">
            <dl>
              <dt class="ld cart_icon_text_wrap">
                <!-- <span class="iconfont icon-gouwuche"></span> -->

                <router-link target="_blank" :to="`/cart/index`"
                  ><img class="shop_icon" src="@/assets/header/shop.png" alt=""
                /></router-link>
                <!-- 没有商品显示0 -->
                <div class="cart_goods_num">
                  ({{
                    cartData.data && cartData.data.availableCartNum
                      ? cartData.data.availableCartNum
                      : 0
                  }})
                </div>
              </dt>
              <dd class="cart_more_view">
                <cart-model></cart-model>
              </dd>
            </dl>
          </div>
        </div>

        <!-- <div v-if="searchBarFixed" class="fixed_header">
          <div class="container_header_box">
            <div class="sld_cart_wrap fixed_sld_cart_wrap">
              <router-link tag="a" class="sld_logo_wrap" :to="`/index`">
                <img
                  :src="configInfo.main_site_logo"
                  :onerror="defaultImg"
                  alt
                />
              </router-link>
            </div>
            <div v-if="!searchBox" class="header_center">
              <div class="product_sort" @click="toGoodsList">
                <img style="margin-right:5px" :src="sortUrl" alt />
                <span class="sort">产品分类</span>
              </div>
              <nav class="fontSize">
                <li class="" v-if="showIndex"><a href="/">首页</a></li>
                <li v-for="(item, index) in navList.data" :key="index">
                  <a href="javascript:void(0)" @click="navClick(item)">{{
                    item.navName
                  }}</a>
                </li>
              </nav>
            </div>
            <div v-else class="sld_seach_box">
              <div class="sld_seach">
                <form class="form" @submit.prevent>
                  <input
                    v-model="keyword"
                    type="text"
                    class="text"
                    autocomplete="off"
                    style="color:rgb(153,153,153);"
                    :placeholder="L['请输入关键词']"
                    @keyup.enter="search"
                  />
                  <input
                    type="submit"
                    :value="L['搜索']"
                    class="button"
                    @click="search"
                  />
                </form>
              </div>
              <div class="hot_search_wrap">
                <div>
                  <template v-for="(item, index) in hotList.data" :key="index">
                    <a href="javascript:void(0)" @click="quickSearch(item)">{{
                      item
                    }}</a>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="sld_cart_wrap">
          <dl class>
            <dd class="cart_more_view">
              <cart-model></cart-model>
            </dd>
          </dl>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, getCurrentInstance, ref, watchEffect, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import CategorySort from './CategorySort'
import CartModel from '@/components/CartModel' // 引入购物车模块

export default {
  name: 'SldHomeTopSearch',
  components: {
    CartModel,
    CategorySort
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const route = useRoute()
    const router = useRouter()
    const showIndex = ref(true)
    const L = proxy.$getCurLanguage()
    const ooimage = ref('')
    const store = useStore()
    const cartData = reactive({ data: {} }) //获取vux的store中的购物车数据
    const logoUrl = ''
    const configInfo = ref(store.state.configInfo)
    const defaultImg = ref(
      'this.src="' + require('../assets/common_top_logo.png') + '"'
    )
    const keyword = ref(
      router.query != undefined &&
        router.query.keyword != undefined &&
        router.query.keyword
        ? router.query.keyword
        : ''
    )
    const searchUrl = require('../assets/header/magnify.png')
    const cartUrl = require('../assets/header/cart.png')
    const picture = require('../assets/picture.png')
    const goods_name = ''
    const searchBarFixed = ref(false)
    const hotList = reactive({ data: [] }) //热门搜索词列表
    const delGoodsCartIds = ref('') //删除商品的id
    const toGoodsList = () => {
      // router.push('/goods/Category') //push产品分类路由
      showCategorySort.value = !showCategorySort.value
    }
    const navList = reactive({ data: [] })
    const sortUrl = require('@/assets/header/menu.png')
    const getNavData = () => {
      proxy.$get('v3/system/front/navigation/list').then(res => {
        console.log('res---导航栏res---', res)
        if (res.state == 200) {
          navList.data = res.data
        }
      })
    }
    onMounted(() => {
      cartData.data = store.state.cartListData
      getInitData()
      getSystemConfigInfo()
      let path = route.path
      if (path == '/index') {
        // dom.style.display = 'block'
        showIndex.value = false
      } else if (path == '/goods/Category') {
        // dom.style.display = 'none'
      }
      getNavData()
    })
    const getInitData = () => {
      proxy
        .$get('v3/system/front/setting/getSettings?names=hot_search_words')
        .then(res => {
          if (res.state == 200) {
            let tmp_data = res.data[0] ? res.data[0].split(',') : []
            hotList.data = tmp_data
          }
        })
    }

    const cart_num = ''
    watchEffect(() => {
      if (router.currentRoute.value.query.keyword != undefined) {
        keyword.value = router.currentRoute.value.query.keyword
      } else {
        keyword.value = ''
      }
      cartData.data = store.state.cartListData
    })

    //搜索事件
    const search = () => {
      console.log(keyword.value)
      if (keyword.value) {
        router.push({
          path: `/goods/list`,
          query: { keyword: keyword.value }
        })
      } else {
        router.push({
          path: `/goods/list`,
          query: { keyword: '' }
        })
      }
    }
    const closeSearch = () => {
      searchBox.value = false
    }
    const toRelease = () => {
      router.push({ path: `/member/xuenjia/fabuxuenjia` })
    }
    // 获取系统配置信息
    const getSystemConfigInfo = () => {
      proxy
        .$get('/v3/system/front/setting/getSettings', {
          names: 'main_site_logo'
        })
        .then(res => {
          ooimage.value = res.data[0]
          console.log(ooimage.value)
        })
        .catch(() => {
          //异常处理
        })
    }

    //热门搜索事件
    const quickSearch = val => {
      router.push({ path: `/goods/list`, query: { keyword: val } })
    }
    //滚动事件
    const handleScroll = () => {
      var height = 600
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop > height) {
        searchBarFixed.value = true
      } else {
        searchBarFixed.value = false
      }
    }
    window.addEventListener('scroll', handleScroll)

    //
    const searchBox = ref(false)
    const showSearchBox = () => {
      searchBox.value = !searchBox.value
    }

    const showCategorySort = ref(false)

    const navClick = val => {
      console.log('val---navClick---0', val)
      proxy.$diyNavTo(JSON.parse(val.data))
    }

    //删除商品 curCartItem: 当前商品信息
    const delCartGoods = curCartItem => {
      if (store.state.loginFlag) {
        //已登录
        delGoodsCartIds.value = curCartItem.cartId
      } else {
        //未登录
        delGoodsCartIds.value = curCartItem.goodsId
      }
      confirmDelGoodsModel()
    }
    //确定删除商品
    const confirmDelGoodsModel = () => {
      if (store.state.loginFlag) {
        // 已登录
        let params = {
          cartIds: delGoodsCartIds.value
        }
        proxy.$post('v3/business/front/cart/deleteCarts', params).then(res => {
          if (res.state == 200) {
            cartData.data = res.data
            ElMessage.success(L['删除成功！'])
          } else {
            ElMessage.error(res.msg)
          }
        })
      } else {
        // 未登录
        //单个商品删除
        cartData.data.storeCartGroupList.map((storeItem, storeIndex) => {
          storeItem.promotionCartGroupList.map(promotItem => {
            promotItem.cartList.map((cartItem, cartIndex) => {
              if (cartItem.goodsId == delGoodsCartIds.value) {
                promotItem.cartList.splice(cartIndex, 1)
              }
            })
            if (promotItem.cartList.length == 0) {
              storeItem.promotionCartGroupList = []
            }
            if (storeItem.promotionCartGroupList.length == 0) {
              cartData.data.storeCartGroupList.splice(storeIndex, 1)
            }
          })
        })
        ElMessage.success(L['删除成功！'])
      }
      store.commit('updateCartListData', cartData.data)
    }

    return {
      L,
      logoUrl,
      searchUrl,
      cartUrl,
      picture,
      goods_name,
      hotList,
      cart_num,
      searchBarFixed,
      keyword,
      search,
      closeSearch,
      toRelease,
      quickSearch,
      delGoodsCartIds,
      delCartGoods,
      cartData,
      configInfo,
      defaultImg,
      getSystemConfigInfo,
      ooimage,
      toGoodsList,
      navList,
      sortUrl,
      searchBox,
      showSearchBox,
      navClick,
      showCategorySort,
      showIndex
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.justdisplay {
  // display: none;
}
.sld_home_top_search {
  display: flex;
  // justify-content: space-between;
  justify-items: center;
  height: 99px;
  position: relative;
  width: 1210px;
  margin: 0 auto;
  padding-left: 0px;
  padding-right: 0px;

  .fixed_header {
    -webkit-animation: searchTop 0.5s ease-in-out;
    animation: searchTop 0.5s ease-in-out;
  }

  @-webkit-keyframes searchTop {
    0% {
      top: -50px;
    }

    to {
      top: 0;
    }
  }

  @keyframes searchTop {
    0% {
      top: -50px;
    }

    to {
      top: 0;
    }
  }

  // &:before {
  //   display: table;
  //   content: ' ';
  // }

  .header_logo {
    position: relative;
    margin-top: 24px;

    .sld_logo_wrap {
      display: block;
      width: 200px;
      height: 60px;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .header_center {
    display: flex;
    flex: 1;
    align-items: center;
    overflow: visible;

    .product_sort {
      // background: $colorMain;
      color: #333333;
      font-size: 18px;
      letter-spacing: 3px;
      line-height: 30px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      cursor: pointer;
      box-sizing: border-box;
      padding: 0 0 0 26px;

      // &:hover {
      //   #category_sort {
      //     display: block;
      //   }
      // }

      img {
        width: 12px;
        height: 12px;
      }
    }

    nav {
      display: flex;
      align-items: center;
      overflow: hidden;
      flex-wrap: wrap;

      a {
        display: inline-block;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #333333;
        font-size: 18px;
        margin: 0 0 0 20px;
        line-height: 37px;
        padding: 0 7px;
        width: max-content;
      }

      a:hover {
        color: $colorMain;
        border-bottom: 3px solid $colorMain;
      }

      .orderHall {
        margin-left: 30px;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
  .header_right {
    display: flex;
    align-items: center;
    img {
      margin-right: 15px;
      cursor: pointer;
    }
    .searchIcon {
    }
    .sld_cart_wrap {
      float: right;
      position: relative;
      z-index: 99;
      height: 40px;
      width: 165px;
      margin-right: 10px;
      margin-top: 9px;

      dl {
        margin-bottom: 0px;
        position: relative;

        .shop_icon {
          width: 32px;
          height: 32px;
        }

        .cart_goods_num {
          position: absolute;
          top: 6px;
          left: 30px;
          font: 14px/18px Verdana;
          color: #ced7df;
          // background: $colorMain;
          text-align: center;
          display: inline-block;
          height: 16px;
          min-width: 16px;
          border: none 0;
          border-radius: 8px;
        }

        dt {
          position: absolute;
          z-index: 3;
          width: 165px;
          height: 38px;
          background-color: #fff;
          cursor: pointer;
          font-weight: 400;

          .iconfont {
            margin: 0 13px 0 12px;
            color: $colorMain;
            font-size: 26px;
            font-weight: 600;
            vertical-align: bottom;
            font-family: 'iconfont' !important;
            font-size: 17px;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            line-height: 36px;
          }

          &.cart_icon_text_wrap {
            a {
              color: #666666;
              font-size: 14px;
              line-height: 36px;
            }
          }
        }

        dd {
          .cart_goods {
            dl {
              padding-top: 8px;
            }

            dd {
              &.cart_goods_price {
                position: static;

                em {
                  margin-right: 6px;
                  width: auto;
                  color: #666;

                  &:nth-child(1) {
                    display: block;
                    font-weight: 600;
                  }

                  &:nth-child(2) {
                    display: block;
                    text-align: right;
                    margin-top: 6px;
                  }
                }
              }
            }
          }
        }
      }

      dd {
        position: absolute;
        top: 38px;
        right: 0;
        width: 355px;
        border: 1px solid #e3e3e3;
        background: #fff;
        z-index: 1;
      }

      &:hover .cart_more_view {
        display: inline-block;
      }
    }
  }
  .fixed_header {
    width: 100%;
    position: fixed;
    background-color: #fff;
    left: 0;
    right: 0;
    top: 0;
    z-index: 999;
    border-bottom: 2px solid $colorMain;

    .sld_cart_wrap {
      margin: 5px;
      margin-right: 40px;
    }

    .container_header_box {
      width: 1200px;
      margin: 0 auto;

      .fixed_sld_cart_wrap {
        margin-right: 170px;
        width: 331px;

        .sld_logo_wrap {
          // display: block;
          // width: 200px;
          // height: 60px;
          // width: 100%;
          // height: 100%;

          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
      .header_center {
        display: flex;
        flex: 1;
        align-items: center;
        overflow: visible;

        .product_sort {
          // background: $colorMain;
          color: #333333;
          font-size: 18px;
          letter-spacing: 3px;
          line-height: 30px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;
          cursor: pointer;
          box-sizing: border-box;
          padding: 0 0 0 26px;

          // &:hover {
          //   #category_sort {
          //     display: block;
          //   }
          // }

          img {
            width: 12px;
            height: 12px;
          }
        }

        nav {
          display: flex;
          align-items: center;
          overflow: hidden;
          flex-wrap: wrap;

          a {
            display: inline-block;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #333333;
            font-size: 18px;
            margin: 0 0 0 20px;
            line-height: 37px;
            padding: 0 7px;
            width: max-content;
          }

          a:hover {
            color: $colorMain;
            border-bottom: 3px solid $colorMain;
          }

          .orderHall {
            margin-left: 30px;
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .elicon {
    font-size: 16px;
    color: #333333;
  }

  .searchFixed {
    display: flex;
  }

  .cart_more_view {
    display: none;

    .empty_cart {
      width: 100%;
      position: relative;

      .empty_cart_line {
        position: absolute;
        width: 163px;
        right: 0;
        height: 2px;
        // top: -2px;
        z-index: 999;
        background: #fff;
      }

      .empty_cart_txt {
        padding: 10px;
        color: #999;
      }
    }
  }
}
.sld_seach_box {
  width: 680px;
  height: 99px;
  margin: 32px auto 0;
  margin-bottom: 3px;

  .sld_seach {
    display: flex;
  }

  .form {
    border: 2px solid $colorMain;
    border: 2px solid #00a2e8;
    // background-color: $colorMain;
    height: 38px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;

    .svg_search_icon {
      color: #c0c0c0;
      width: 18px;
      height: 18px;
      margin-left: 5px;
      margin-top: 9px;
      cursor: pointer;
      position: absolute;
    }

    .text {
      width: 591px;
      height: 38px;
      -webkit-appearance: none;
      -webkit-border-radius: 0;
      padding: 5px 5px 5px 30px;
      background-position: 0 -360px;
      background-color: #fff;
      background-repeat: repeat-x;
      font-family: arial, '\5b8b\4f53';
      font-size: 14px;
      outline: none;
      border: none;
    }
    .svg_close_icon {
      color: #c0c0c0;
      width: 18px;
      height: 22px;
      margin-top: 5px;
      position: absolute;
      right: 10px;
      cursor: pointer;
    }

    // input {
    //   margin: 0;
    //   padding: 0;
    //   height: 34px;
    //   border: 0;
    // }

    // .button {
    //   width: 103px;
    //   background: $colorMain;
    //   font-size: 16px;
    //   font-weight: 600;
    //   color: #fff;
    //   float: right;
    //   cursor: pointer;
    // }
  }
  .release {
    width: 100px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    line-height: 38px;
    background-color: #00a2e8;
    margin-left: 2px;
    cursor: pointer;
  }

  .hot_search_wrap {
    height: 30px;
    line-height: 30px;
    color: #999;
    overflow: hidden;

    strong {
      float: left;
      font-weight: 400;
    }

    a {
      color: #666;

      &:link,
      &:visited {
        float: left;
        margin-right: 10px;
      }

      &:hover {
        color: $colorMain;
      }
    }
  }
}
</style>
